export default "__VITE_ASSET__Cb5Xss5O__"